export const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://pomogator-be.duckdns.org"
    : "http://127.0.0.1:8000";
